import React, { useContext } from "react";
import Chart from "react-apexcharts";
import { ProyectosContext } from "../../context/ProyectosContext";

// Same colors and gradients as Progreso de Obra.
const getPrimary = () => {
  try {
    const value = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue("--primary")
      .trim();
    return value || "#b76d4f";
  } catch (error) {
    return "#b76d4f";
  }
};

const getSeries = () => {
  const primary = getPrimary();
  return [
    { key: "programado", label: "Programado", color: "#007991", hasta: "#05d4c6" },
    { key: "fisico", label: "Real físico", color: "#89d405", hasta: "#b3ff00" },
    { key: "contrato", label: "Real contrato", color: primary, hasta: primary },
    { key: "pagado", label: "Pagado", color: "#FF8008", hasta: "#ffb066" },
  ];
};

const redondear = (value) => Math.round(value * 1000) / 10;

const calcularValores = (p, avance) => {
  const totales = avance?.totales;
  return {
    programado: p ? redondear(p.programado) : null,
    fisico: p ? redondear(p.real) : null,
    contrato:
      totales && totales.total_contrato > 0
        ? redondear(totales.devengado / totales.total_contrato)
        : null,
    pagado:
      totales && totales.total_contrato > 0
        ? redondear(totales.pagado / totales.total_contrato)
        : null,
  };
};

// proyeccion / financiero: saved with a report; otherwise the ones in context.
const ProgramadoVsReal = ({ proyeccion, financiero, height = 380 }) => {
  const { proyeccion: proyeccionObra, avanceFinanciero } =
    useContext(ProyectosContext);
  const conDatos = proyeccion !== undefined || financiero !== undefined;
  const datosProyeccion = conDatos ? proyeccion : proyeccionObra;
  const datosFinanciero = conDatos ? financiero : avanceFinanciero;
  const valores =
    datosProyeccion === undefined || datosFinanciero === undefined
      ? undefined
      : calcularValores(datosProyeccion, datosFinanciero);

  if (valores === undefined) {
    return <div className="spinner-border spinner-border-sm m-3" />;
  }

  const series = getSeries().filter(({ key }) => valores[key] !== null);
  if (series.length === 0) {
    return (
      <p className="text-muted px-3 mb-0">
        No hay suficiente información para comparar el avance.
      </p>
    );
  }
  const datos = series.map(({ key }) => valores[key]);
  const tope = Math.ceil((Math.max(100, ...datos) + 10) / 20) * 20;

  return (
    <div className="px-2">
      <Chart
        type="bar"
        height={height}
        series={[{ name: "Avance", data: datos }]}
        options={{
          chart: {
            toolbar: { show: false },
            fontFamily: "inherit",
            animations: { enabled: !conDatos },
          },
          colors: series.map(({ color }) => color),
          fill: {
            type: "gradient",
            gradient: {
              type: "vertical",
              shadeIntensity: 0,
              gradientToColors: series.map(({ hasta }) => hasta),
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              distributed: true,
              columnWidth: "55%",
              borderRadius: 4,
              borderRadiusApplication: "end",
              dataLabels: { position: "top" },
            },
          },
          stroke: { show: true, width: 2, colors: ["#fff"] },
          dataLabels: {
            enabled: true,
            offsetY: -22,
            formatter: (value) => `${value}%`,
            style: { colors: ["#212529"], fontSize: "13px", fontWeight: 700 },
          },
          legend: { show: false },
          grid: {
            borderColor: "#eee",
            xaxis: { lines: { show: false } },
            yaxis: { lines: { show: true } },
          },
          xaxis: {
            categories: series.map(({ label }) => label),
            labels: { style: { fontSize: "12px" }, trim: false },
          },
          yaxis: {
            min: 0,
            max: tope,
            tickAmount: tope / 20,
            labels: { formatter: (value) => `${Math.round(value)}%` },
          },
          tooltip: {
            y: { formatter: (value) => `${value}%`, title: { formatter: () => "" } },
          },
        }}
      />
      <div
        className="small text-muted mx-2 p-2 rounded bg-light"
        style={{ borderLeft: "3px solid var(--primary)" }}
      >
        Programado y real físico salen del cronograma a hoy.
        {series.some(({ key }) => key === "contrato") &&
          " Real contrato es el avance financiero (importe de los conceptos según su avance) y pagado es lo pagado, ambos sobre el total de los contratos."}
      </div>
    </div>
  );
};

export default ProgramadoVsReal;
